import { render, staticRenderFns } from "./DetailAttributes.vue?vue&type=template&id=7069b054&scoped=true&"
import script from "./DetailAttributes.vue?vue&type=script&lang=js&"
export * from "./DetailAttributes.vue?vue&type=script&lang=js&"
import style0 from "./DetailAttributes.vue?vue&type=style&index=0&id=7069b054&prod&lang=scss&scoped=true&"
import style1 from "./DetailAttributes.vue?vue&type=style&index=1&id=7069b054&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7069b054",
  null
  
)

export default component.exports